import { createSlice } from "@reduxjs/toolkit";
import { getTags } from "services";

const initialState = {
  carpeta: "",
  nuevaCarpeta: "",
  creadaNew: "",
};

export const cursosSlice = createSlice({
  name: "cursos_slice",
  initialState,
  reducers: {
    setCarpeta: (state, action) => {
      state.carpeta = action.payload;
    },
    setNuevaCarpeta: (state, action) => {
      state.nuevaCarpeta = action.payload;
    },
    setCreadaNew: (state, action) => {
      state.creadaNew = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => getTags.endpoints.getTags.matchFulfilled(action),
      (state, action) => {
        state.creadaNew =
          action.payload?.find((el) => el?.nombre === state.nuevaCarpeta)
            ?.url || "";
      }
    );
  },
});

export const { setCarpeta, setNuevaCarpeta, setCreadaNew } =
  cursosSlice.actions;

// Selector de conveniencia para acceder al estado de cursos
export const cursos_slice = (state) => state.cursos;

export default cursosSlice.reducer;
